import * as React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from "gatsby"
import {
  footerStyle,
  copyright,
  address,
  emphasise,
  footerNavList,
  socialLink
} from "./footer.module.css"
import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons"

export function Footer() {
  return (
    <footer className={footerStyle}>
      <nav aria-label="footer">
        <ul className={footerNavList}>
          <li>
            <Link to="/about/">About & Contact Us</Link>
          </li>
          <li>
            <Link to="/newsletter/">Newsletter</Link>
          </li>
          <li>
            <Link to="/policies/privacy-policy/">Privacy Policy</Link>
          </li>
          <li>
            <Link to="/policies/product-safety/">Product Safety</Link>
          </li>
          <li>
            <Link to="/policies/returns-policy/">Returns</Link>
          </li>
          <li>
            <Link to="/policies/shipping/">Shipping</Link>
          </li>
          <li>
            <Link to="/policies/terms-of-service/">Terms of Service</Link>
          </li>
          <li>
            <span>
              <a className={socialLink} href="https://facebook.com/hoopsandcrossesuk" title="Hoops & Crosses on Facebook">
                <FontAwesomeIcon size="lg" icon={faFacebook}></FontAwesomeIcon>
              </a>
              <a className={socialLink} href="https://instagram.com/hoopsandcrossesuk" title="Hoops & Crosses on Instagram">
                <FontAwesomeIcon size="lg" icon={faInstagram}></FontAwesomeIcon>
              </a>
            </span>
          </li>
          <li className={copyright}>Copyright &copy; {new Date().getFullYear()} · All rights reserved</li>
          <li className={address}>Lucy Todd (t/a Hoops & Crosses), c/o 132 Rectory Road, Worthing, BN14 7PJ, United Kingdom</li>
          <li className={address}><span><span className={emphasise}>EU Responsible Person (EU RP):</span> EU Compliance Partner, Pärnu mnt. 139b – 14, 11317 Tallinn, Estonia
            <br/><a href="mailto:hello@eucompliancepartner.com">hello@eucompliancepartner.com</a> | <a href="https://www.eucompliancepartner.com">https://www.eucompliancepartner.com</a> | +33757690241</span>
          </li>
        </ul>
      </nav>
    </footer>
  )
}
